module.exports = __webpack_public_path__ + "static/media/spinner.db31c56b.svg";